// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgBitcoinCircle = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M21.25 12a9.25 9.25 0 1 0-18.5 0 9.25 9.25 0 0 0 18.5 0M12 1.25c5.937 0 10.75 4.813 10.75 10.75S17.937 22.75 12 22.75 1.25 17.937 1.25 12 6.063 1.25 12 1.25m.75 4.25a.75.75 0 0 0-1.5 0v.758a46 46 0 0 0-1.44-.006l-.214.002A1.353 1.353 0 0 0 8.25 7.606v8.788c0 .746.604 1.348 1.346 1.352l.214.002c.48.003.966.006 1.44-.006v.758a.75.75 0 0 0 1.5 0v-.87a6 6 0 0 0 .885-.195c.585-.182 1.135-.484 1.532-1 .4-.519.583-1.172.583-1.935 0-.83-.231-1.522-.71-2.051a2.7 2.7 0 0 0-.525-.449q.286-.188.526-.449c.478-.529.709-1.22.709-2.051 0-.763-.182-1.416-.583-1.936-.397-.515-.947-.817-1.532-1a6 6 0 0 0-.885-.193zm.193 5.551c-.55.138-1.205.185-1.942.199a48 48 0 0 0-1.251-.004V7.753c1.467-.009 2.625-.01 3.44.244.394.123.638.287.79.483.148.193.27.497.27 1.02 0 .541-.144.848-.322 1.045-.192.212-.502.385-.985.506M11 12.751c-.416.008-.838.006-1.251.003v3.493c1.467.009 2.625.01 3.44-.244.394-.123.638-.287.79-.483.148-.193.27-.497.27-1.02 0-.541-.144-.848-.322-1.045-.192-.212-.502-.385-.985-.506-.55-.138-1.205-.185-1.942-.199Z"
    />
  </svg>
);
export const BitcoinCircleIcon = forwardRef(SvgBitcoinCircle);
